import configureStore from "./common/utils/configureStore";

const store = configureStore({});

export default store;
